module.exports = __webpack_public_path__ + "img/Monte_Kope_20.0ebff6a0.jpg";